import { render, staticRenderFns } from "./ticket_modal.vue?vue&type=template&id=7045f1f3&"
import script from "./ticket_modal.vue?vue&type=script&lang=js&"
export * from "./ticket_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports